<template>

    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">메인 이미지/비디오 관리</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body p-3">
        <el-row :gutter="10">
          <el-col :span="12" >
            슬라이드 딜레이 (초) : 
            <div class="dp-inblock" style="width:90px"><el-input-number placeholder="Please input" size="small" v-model="delay"></el-input-number>
            </div>
            <el-button class="ml-5" size="small" type="primary" @click="saveDelay">저장</el-button>

          </el-col>
          <el-col :span="12" class="text-right">

            <el-upload
                    class="dp-inblock"
                    ref="mediaInfo"
                    action="/api/settings/info/main-image/upload"
                    accept="video/*,image/*"
                    :headers="header"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    :auto-upload="true">
                    <el-button slot="trigger" size="small" type="primary" >이미지/비디오(mp4) 추가</el-button>
            </el-upload>
          </el-col>
        </el-row>

      <el-row :gutter="10">
      <el-col :span="24" class="mt-2">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="items"
                  :header-cell-style="tableRowStyle">

          <el-table-column
            width="80"
            label="종류">
            <template slot-scope="{row}">
              <span v-if="row.type === 'image'">이미지</span>
              <span v-if="row.type === 'video'">비디오</span>
            </template>
          </el-table-column>

          <el-table-column
            width="180"
            label="Blur효과">
            <template slot-scope="{row}">
              <el-input-number size="small" v-model="row.blur" :precision="1" :step="0.1" :max="10" :min="0" @change="blurChange"></el-input-number>
            </template>
          </el-table-column>

          <!-- <el-table-column
            prop="src"
            label="경로">
          </el-table-column> -->
                  
          <el-table-column
          align="center"
            label="미리보기">
            <template slot-scope="{row}">
              <img v-if="row.type === 'image'" :src="row.src" :style="`height: 120px; filter: blur(${row.blur}px);`"/>
              <video v-if="row.type === 'video'" :style="`height: 120px; filter: blur(${row.blur}px);`">
                <source :src="row.src" type="video/mp4">
              </video>              
            </template>
          </el-table-column>

          <el-table-column
            width="175"
            label="편집">
            <template slot-scope="props">
              <el-button size="mini" title="위로이동" type="info" icon="el-icon-top" @click="up(props.row)"></el-button>
              <el-button size="mini" title="아래로이동" type="info" icon="el-icon-bottom" @click="down(props.row)"></el-button>
              <el-button size="mini" title="삭제" type="danger" icon="el-icon-delete-solid" @click="remove(props.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      </el-row>


      </div>
      <div class="modal-footer">
            <el-button @click="$emit('dismiss')">닫 기</el-button>
      </div>
    </div>

</template>

<script>

import MainImageProxy from '@/proxies/MainImageProxy';

export default {
    created() {
        this.getList()
    },
    props: {
        handler: {
            type: Function
        }
    },
    data() {
      return {
        items: [],
        delay: 6,
        header: {
          Authorization:$cookies.get('id_token')
        }

      }
    },    
    methods: {
        uploadSuccess(response, files, fileList) {
          if (response.header.returnCode === "OK") {
            this.$refs["mediaInfo"].clearFiles();
            this.getList();
            alert("저장되었습니다.");
          } else {
            alert(response.header.resultMessages);
          }
        },
        tableRowStyle() {
            return this.$store.state.common.tableHeaderCellStyle;
        },
        remove( id ) {
          if(confirm('삭제 하시겠습니까?')) {

            const index = this.items.findIndex(function(item) {
                return item.id === id;
            });

            if (index !== -1) {
                this.items.splice(index, 1);

                new MainImageProxy()
                .saveList( this.items )

            }            

          }  
        },
        blurChange() {

          new MainImageProxy()
            .saveList( this.items )

        },
        up( target ) {

          const index = this.items.findIndex(function(item) {
                return item.id === target.id;
          });

          if(index == 0) {
            alert('더이상 위로 이동할 수 없습니다.');
            return;
          }

          if (index !== -1) {
            this.items.splice(index, 1);
            this.items.splice(index-1,0, target );

            new MainImageProxy()
            .saveList( this.items )
          }  

        },

        down( target ) {

          const index = this.items.findIndex(function(item) {
                return item.id === target.id;
          });

          if(index + 1 == this.items.length) {
            alert('더이상 아래로 이동할 수 없습니다.');
            return;
          }

          if (index !== -1) {
            this.items.splice(index, 1);
            this.items.splice(index + 1, 0, target );

            new MainImageProxy()
            .saveList( this.items )
          }  


        },

        saveDelay() {
          console.log(this.delay)
          new MainImageProxy()
          .saveDelay( this.delay )
          .then(() => alert('슬라이드 딜레이가 "'+this.delay+'"초로 저장 되었습니다.'))

        },

        getList() {

          return new MainImageProxy()
          .all()
          .then((response) => {
            this.items = [...response.item.items];
            this.delay = response.item.delay;
            return response.item;
          })          

            
        }
    },

}
</script>